module.exports = __webpack_public_path__ + "img/clouds_1_day.9bc43756.svg";